export const getErrorMessage = (statusCode: number, defaultMessage?: string): string => {
  const errorMessages: Record<number, string> = {
    400: 'Bad request. Please check your input and try again.',
    401: 'Your session has expired. Please log in again.',
    403: 'You do not have permission to perform this action.',
    404: 'The requested resource was not found.',
    408: 'Request timeout. Please try again.',
    409: 'A conflict occurred. The resource may have been modified.',
    422: 'Invalid data provided. Please check your input.',
    429: 'Too many requests. Please slow down and try again later.',
    500: 'An internal server error occurred. Please try again later.',
    502: 'Bad gateway. The server is temporarily unavailable.',
    503: 'Service unavailable. Please try again later.',
    504: 'Gateway timeout. The server took too long to respond.',
  };

  return errorMessages[statusCode] || defaultMessage || 'An unexpected error occurred. Please try again.';
};

